import React, { Component } from 'react'
import {
    Button, Form, FormGroup, Label, Input, CustomInput, Col, Row, Progress
} from 'reactstrap'
import './formProducto.css'
import Categoria from '../../../utilitarios/productoCategoria'
const categoria = new Categoria

export default class FormProducto extends Component {
    constructor(props) {
        super(props)

        this.state = {
            categorias: []
        }
        this.onChange = this.onChange.bind(this)
        this.onChangeActivo = this.onChangeActivo.bind(this)
        this.onChangeAgotado = this.onChangeAgotado.bind(this)
        this.onChangeImg = this.onChangeImg.bind(this)
    }

    onChange(e) {
        const prod = {
            ...this.props.producto,
            [e.target.id]: e.target.value
        }
        this.props.editarProducto(prod)
    }

    onChangeActivo(e) {
        const prod = {
            ...this.props.producto,
            Activo: !this.props.producto.Activo
        }
        this.props.editarProducto(prod)
    }

    onChangeAgotado(e) {
        const prod = {
            ...this.props.producto,
            Agotado: !this.props.producto.Agotado
        }
        this.props.editarProducto(prod)
    }

    onChangeImg(e) {
        this.props.guardarImagen(e)
    }

    componentDidMount() {
        const _this = this
        categoria.getCategorias().then(categorias => _this.setState({ categorias }))
    }


    render() {
        return (
            <Form className="formEdicion" onSubmit={this.props.guardarCambios}>
                <FormGroup>
                    <Label for="Codigo">Código</Label>
                    <Input onChange={this.onChange} value={this.props.producto.Codigo} type="text" id="Codigo" placeholder="Código identificador" required />
                </FormGroup>
                <FormGroup>
                    <Label for="Descripcion">Descripción</Label>
                    <Input onChange={this.onChange} value={this.props.producto.Descripcion} type="text" id="Descripcion" placeholder="Descripción" required />
                </FormGroup>
                <FormGroup>
                    <Label for="Marca">Marca</Label>
                    <Input onChange={this.onChange} value={this.props.producto.Marca} type="text" id="Marca" placeholder="Marca" />
                </FormGroup>
                <FormGroup>
                    <Label for="Categoria">Categoría</Label>
                    {/* <Input onChange={this.onChange} value={this.props.producto.Categoria} type="text" id="Categoria" placeholder="Categoría" /> */}
                    <CustomInput type="select" onChange={this.onChange} value={this.props.producto.Categoria} id="Categoria" >
                        {
                            this.state.categorias.map(cat => <option key={cat.id} value={cat.data().Descripcion}>{cat.data().Descripcion}</option>)
                        }
                    </CustomInput>
                </FormGroup>
                <Row form>
                    <Col md={6}>
                        <FormGroup>
                            <Label for="Precio">Precio</Label>
                            <Input onChange={this.onChange} value={this.props.producto.Precio} type="number" id="Precio" placeholder="Precio del producto" required />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Label for="PrecioPuntos">Precio para puntos</Label>
                            <Input onChange={this.onChange} value={this.props.producto.PrecioPuntos} type="number" id="PrecioPuntos" placeholder="Precio para puntaje" />
                        </FormGroup>
                    </Col>
                </Row>
                <Row form className="rowChecks">
                    <Col md={6}>
                        <Label for="Activo"> </Label>
                        <CustomInput onChange={this.onChangeActivo} checked={this.props.producto.Activo} type="checkbox" id="exampleCustomCheActivockbox2" label="Activo" className="CheckBox" />
                    </Col>
                    <Col md={6}>
                        <Label for="Agotado"> </Label>
                        <CustomInput onChange={this.onChangeAgotado} checked={this.props.producto.Agotado} type="checkbox" id="Agotado" label="Agotado" className="CheckBox" />
                    </Col>
                </Row>
                <FormGroup>
                    <Input onChange={this.onChangeImg} className="btn btn-outline-dark btn-sm" type="file" name="file" id="Img" />
                    {
                        this.props.ImgProgress > 0 && <Progress id="ImgProgress" animated color="warning" value={this.props.ImgProgress} />
                    }
                </FormGroup>
                <FormGroup>
                    <Label for="Detalle">Detalle</Label>
                    <Input onChange={this.onChange} value={this.props.producto.Detalle} type="textarea" id="Detalle" />
                </FormGroup>

                <Button color="success">Guardar</Button>
            </Form>
        )
    }


}